import { RootState } from "store/store";

export const compressSelector = (state: RootState) => state.compress;
